<app-header></app-header>
<div class="container container__custom-width">
  <div
    *ngIf="paymentResultSuccess"
    class="payment-result-wrapper d-flex justify-content-center align-items-center flex-column"
  >
    <img class="mb-3" src="/assets/images/success_1.svg" />
    <p class="f-size-18 f-color-dark fw-bold text-center">
      გადახდა წარმატებით განხორციელდა
    </p>
    <p
      class="f-size-14 fw-medium f-color-vibrant-blue text-center cursor-pointer"
      (click)="navigateToHome()"
    >
      მთავარ გვერდზე გადასვლა
    </p>
  </div>
  <div
    *ngIf="!paymentResultSuccess"
    class="payment-result-wrapper d-flex justify-content-center align-items-center flex-column"
  >
    <img class="mb-3" src="/assets/images/red-error.svg" />
    <p class="f-size-18 f-color-dark fw-bold text-center">გადახდა უარყოფილია</p>
    <p
      class="f-size-14 fw-medium f-color-vibrant-blue text-center cursor-pointer"
      (click)="navigateToHome()"
    >
      მთავარ გვერდზე გადასვლა
    </p>
  </div>
</div>
<app-footer></app-footer>
